export function ifSpaceOrEnter<T extends HTMLElement>(
    event: React.KeyboardEvent<T>,
    callback?: (event: React.KeyboardEvent<T>) => void,
    preventDefault = true,
) {
    const isSpaceOrEnter = ["Enter", "NumpadEnter", "Space"].includes(event.code)

    if (isSpaceOrEnter) {
        if (preventDefault) {
            event.preventDefault()
        }
        callback?.(event)
    }
}
